import React from "react";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import { useTranslation } from "react-i18next";

const AlertForJudgeAdmin = ({ noResultAnnounceAlert, setNoResultAnnounceAlert }) => {
	const { t } = useTranslation();
	return (
		<>
			{/*----------- 결과통보 버튼 클릭 시 모달 - 전체 심사역이 심사를 안했을 때*/}
			<AlertTemplate
				alertModalState={noResultAnnounceAlert}
				setAlertModalToggle={setNoResultAnnounceAlert}
				alertType="info"
			>
				<p className="alert-content">
					<div className="modal-text pre">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.alertForJudgeAdmin.AlertForJudgeAdmin.alert"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoResultAnnounceAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.alertForJudgeAdmin.AlertForJudgeAdmin.confirm"
						)}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default AlertForJudgeAdmin;
